<template>
  <div>
    <header-component/>

    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header">
          <h3 
            class="mb-0" 
            style="text-transform:capitalize;">Service Categories List</h3>
          <div class="col-lg-12 col-5 text-right">
            <base-button 
              size="sm" 
              type="primary" 
              @click="createServiceCategory">Add New</base-button>
          </div>
        </div>
        <el-table
          :data="sortedServiceCategoryList"
          class="table-responsive table-flush"
          header-row-class-name="thead-light"
        >
          <el-table-column 
            label="Name" 
            prop="label"/>
          <el-table-column 
            label="Initial Letter" 
            prop="letter"/>
          <el-table-column min-width="70px">
            <template slot-scope="scope">
              <el-dropdown 
                slot="dropdown" 
                @command="command => handleAction(scope.row, command)">
                <el-button 
                  type="primary" 
                  size="mini">
                  Actions
                  <i class="el-icon-arrow-down el-icon--right" />
                </el-button>
                <el-dropdown-menu 
                  slot="dropdown" 
                  class="dropdown-menu dropdown-menu-arrow show">
                  <el-dropdown-item command="edit">Edit</el-dropdown-item>
                  <el-dropdown-item command="delete" style="color: #f56c6c">Delete</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
        :visible.sync="addServiceCategory" 
        title="Add Service Category">
        <add-serviceCategory @close="addServiceCategory=false"/>
      </el-dialog>
    </div>
  </div>
</template>


<script>
import {
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog,
  Button
} from "element-ui";
import { mapGetters, mapActions, mapMutations } from "vuex";
import AddServiceCategory from "./AddServiceCategory";
import headerComponent from "../Components/HeaderComponent";
import Api from "@/middleware/api";
import endpoints from "@/utils/constants";
// import { map } from 'd3';

export default {
  data: () => {
    return {
      addServiceCategory: false,
    };
  },

  computed: {
    ...mapGetters({
      serviceCategory: "serviceCategory/getServiceCategory",
      serviceCategoryList: "serviceCategory/getServiceCategoryList",
    }),
    sortedServiceCategoryList() {
      return [...(this.serviceCategoryList || [])].sort((a, b) =>
        (a.label || '').localeCompare(b.label || '')
      );
    }
  },

  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    [Button.name]: Button,
    "add-serviceCategory": AddServiceCategory,
    "header-component": headerComponent,
  },

  mounted() {
    this.getServiceCategoryList();
  },

  methods: {
    ...mapActions({
      getServiceCategoryList: "serviceCategory/getServiceCategoryList",
      fetchServiceCategory: "serviceCategory/fetchServiceCategory",
    }),

    ...mapMutations({
      setServiceCategory: "serviceCategory/setServiceCategory",
      resetServiceCategory: "serviceCategory/resetServiceCategory",
    }),

    handleAction(serviceCategory, command) {
      if (command === "edit") {
        this.fetchServiceCategory(serviceCategory.serviceCategoryId).then(
          (res) => {
            this.addServiceCategory = true;
            this.setServiceCategory(res);
          }
        );
      } else if (command === "delete") {
        if (!window.confirm("Delete this service category?")) return;
        new Api().call("delete", `${endpoints.LARAVEL_BASE_URL}/api/v1/service-categories/${serviceCategory.serviceCategoryId}`)
          .then(() => {
            this.getServiceCategoryList();
            window.notify && window.notify({ message: "Deleted", type: "success", title: "Success" });
          })
          .catch(() => {
            window.notify && window.notify({ message: "Failed to delete", type: "danger", title: "Error" });
          });
      }
    },

    createServiceCategory() {
      this.resetServiceCategory();
      this.addServiceCategory = true;
    },
  },
};
</script>
